import { weekdayName } from '../../i18n/calendarLabels';
import React, {useEffect, useState} from "react";
import Checkbox from "../common/Checkbox";
import Modal from 'react-bootstrap/Modal';
import Input from "../common/Input";
import SelectInput from "../common/SelectInput";
import { useTranslation } from 'react-i18next';

function SchoolClassesFilterForm({filters, handleFilterChange, clearFilters, handleBooleanFilterChange, teachers, weekdays, classTypes}) {
  const { t: tr, i18n } = useTranslation();
  const [isModalShowing, setIsModalShowing] = useState(false);

  const handleShowModal = () => {
    setIsModalShowing(!isModalShowing);
  };

  return (
    <div>
      <button type="button" className="btn manage-button btn-dark mr-2" onClick={handleShowModal}><i className="fas fa-filter fa-lg"></i></button>
      <Modal show={isModalShowing} onHide={handleShowModal} className="custom-modal" centered>
        <Modal.Body>
          <div className="row d-flex m-0">
            <SelectInput
              label={tr("manage:teacher_226")}
              onChange={handleFilterChange}
              name="teacherId"
              value={filters.teacherId}
              defaultOption="Wybierz nauczyciela"
              options={teachers.map(t => ({
                value: t.id,
                text: `${t.firstName} ${t.lastName}`,
              }))}
              className="col-sm-6 px-0 pr-sm-3"
            />
            <SelectInput
              label={tr("manage:type_129")}
              onChange={handleFilterChange}
              name="classTypeId"
              value={filters.classTypeId}
              defaultOption="Wybierz typ zajęć"
              options={classTypes.map(classType => ({
                value: classType.id,
                text: classType.name,
              }))}
              className="col-sm-6 px-0"
            />
          </div>
          <div className="row d-flex m-0">
            <SelectInput
              label={tr("manage:dayOfTheWeek_223")}
              onChange={handleFilterChange}
              name="dayOfWeek"
              value={filters.dayOfWeek}
              defaultOption="Wybierz dzień tygodnia"
              options={weekdays.map(d => ({
                value: d.id,
                text: weekdayName(d.id, i18n.language),
              }))}
              className="col-sm-6 p-0"
            />
            <Input
              label={tr("manage:from_295")}
              type='time'
              onChange={handleFilterChange}
              name="startTime"
              value={filters.startTime}
              placeholder={tr("manage:lessonStart_225")}
              className="col-6 col-sm-3 pr-2 pl-0 pl-sm-3 pr-sm-0"
            />
            <Input
              label={tr("manage:to_296")}
              type='time'
              onChange={handleFilterChange}
              name="endTime"
              value={filters.endTime}
              placeholder={tr("manage:lessonEnd_297")}
              className="col-6 col-sm-3 pl-2 pl-sm-3 pr-0"
            />
          </div>
          <div className="row d-flex m-0">
            <Input
              type="date"
              label={tr("manage:firstLesson_298")}
              id="fromDate"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleFilterChange}
              className="col-sm-6 px-0 pr-sm-2"
            />
            <Input
              type="date"
              label={tr("manage:lastLesson_299")}
              id="tillDate"
              name="tillDate"
              value={filters.tillDate}
              onChange={handleFilterChange}
              className="col-sm-6 px-0 pl-sm-2"
            />
          </div>

          <div className="mt-3">
            <Checkbox label={tr("manage:oneoffClassesOnly_300")} onChange={() => handleBooleanFilterChange('showOnlyNotRepeating')} name="showOnlyNotRepeating" isChecked={filters.showOnlyNotRepeating}/>
            <Checkbox label={tr("manage:recurringClassesOnly_301")} onChange={() => handleBooleanFilterChange('showOnlyRepeating')} name="showOnlyRepeating" isChecked={filters.showOnlyRepeating}/>
            <Checkbox label={tr("manage:anyNotesOrComments_302")} onChange={() => handleBooleanFilterChange('comment')} name="comment" isChecked={filters.comment}/>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="btn manage-button btn-success mr-auto" onClick={clearFilters}><i className="fas fa-undo" /></button>
          <button type="button" className="btn manage-button manage-teal-button" onClick={handleShowModal}>{tr("common:back")}</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SchoolClassesFilterForm;
